<template>
  <div>
    <purchases :id="order.id" :order="order" />
    <promotions :order="order"  :partner="partner" />
    <div class="row">
      <div class="col-12 col-md-6">
        <informator
          title="Регион"
          titleKey="region"
          v-model="data.region"
          :partner="partner"
          link="get-regions"
        />
      </div>
      <div class="col-12 col-md-6">
        <informator
          title="Город / район"
          titleKey="city"
          v-model="data.city"
          :partner="partner"
          :link="`get-districts?region_id=${
            data.region ? data.region.guid : ''
          }`"
        />
      </div>
      <div class="col-12 col-md-6">
        <informator
          title="Образование"
          titleKey="education_degree"
          v-model="data.education_degree"
          :partner="partner"
          link="get-education-levels"
        />
      </div>

      <div class="col-12 col-md-6">
        <informator
          title="Рекомендации клиента"
          titleKey="agent_recommendation"
          v-model="data.agent_recommendation"
          :partner="partner"
          link="get-agent-recommendations"
        />
      </div>
      <div class="col-12">
        <informator
          title="Категория товаров"
          titleKey="product_category"
          v-model="product_category"
          :partner="partner"
          link="get-products-categories"
        />
      </div>
      <div class="col-12">
        <h4>
          {{
            "relation_people"
              | setText("Заполните информацию двух близких людей")
          }}
        </h4>

        <h5>{{ "men_1" | setText("Человек 1") }}</h5>
        <informator
          title="Тип родства"
          titleKey="type_relation"
          v-model="data.additional_contact[0].relation"
          :partner="partner"
          link="get-relation-degrees"
        />
        <fg-input
          :type="`text`"
          :label="`Полное имя родственника`"
          :labelKey="`full_name_relation`"
          v-model="data.additional_contact[0].name"
        ></fg-input>
        <fg-input
          v-mask="`+998#########`"
          :label="`Номер телефона родственника`"
          :labelKey="`phone_relation`"
          v-model="data.additional_contact[0].additional_client_number"
        ></fg-input>
      </div>
      <div class="col-12">
        <h5>{{ "men_2" | setText("Человек 2") }}</h5>
        <informator
          title="Тип родства"
          titleKey="type_relation"
          v-model="data.additional_contact[1].relation"
          :partner="partner"
          link="get-relation-degrees"
        />
        <fg-input
          :type="`text`"
          :label="`Полное имя родственника`"
          :labelKey="`full_name_relation`"
          v-model="data.additional_contact[1].name"
        ></fg-input>
        <fg-input
          v-mask="`+998#########`"
          :label="`Номер телефона родственника`"
          :labelKey="`phone_relation`"
          v-model="data.additional_contact[1].additional_client_number"
        ></fg-input>
        <hr />
      </div>

      <div class="col-12 col-md-12">
        <checkbox
          id="has_green_card"
          v-model="data.has_green_card"
          color="#2c75ff"
        >
          <label for="has_green_card">{{
            "green_card" | setText("Есть Green Card?")
          }}</label>
        </checkbox>
        <br />
      </div>

      <div class="col-12 col-md-12">
        <fg-input
          :type="`text`"
          :labelKey="`street`"
          :label="`Улица`"
          v-model="data.street"
        ></fg-input>
      </div>

      <div class="col-12 col-md-12">
        <label>{{ "activity" | setText("Тип занятости клиента") }}</label>
        <select class="form-control" v-model="data.field_of_activity">
          <option
            :value="activity.key"
            v-for="(activity, k) in field_of_activities"
            :key="k"
          >
            {{ activity.titleKey | setText(activity.title) }}
          </option>
        </select>
      </div>
      <div class="col-12 col-md-12">
        <label>{{ "income" | setText("Вид дохода") }}</label>
        <multiselect
          v-model="source_of_income_values"
          :showLabels="false"
          label="title"
          track-by="key"
          :options="source_of_incomes"
          :multiple="true"
        ></multiselect>
      </div>
    </div>

    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  watch: {
    "order.card": {
      handler: function (val) {
        try {
          this.data.card_number = val.card_number
            ? val.card_number.replace(/\s+/g, "")
            : "";

          this.data.card_expiry = val.exp ? val.exp.replace("/", "") : "";
        } catch (error) {}
      },
      deep: true,
    },
  },
  components: {
    informator: () => import("./Informator"),
    purchases: () => import("@/components/Item/Order/Purchases"),
    promotions: () => import("@/components/Item/Order/Promotions"),
  },
  computed: {
    products() {
      let products = [];
      if (this.order && this.order.purchases) {
        for (let i = 0; i < this.order.purchases.length; i++) {
          products.push({
            product_category: this.product_category,
            is_env_friendly: true,
            price: this.order.purchases[i]["price"],
            product_name: this.order.purchases[i]["name"],
          });
        }

        return products;
      }
      return [];
    },
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    this.data.street = this.order.client.passport_address;
  },
  methods: {
    send() {
      this.$loading(true);
      this.data["loan_id"] = this.transaction["exchange_id"];
      this.data["source_of_income"] = this.source_of_income_values.map((item) =>
        item.key.toString()
      );
      this.data["products"] = this.products;

      this.$http({
        url: `${this.partner["endpoint_url"]}customer-data`,
        method: "POST",
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
          "agent-id": this.partner["api_public_key"],
        },
        data: this.data,
      })
        .then((response) => {
          if (response.data) {
            if (response.data.loan_id) {
              this.createTransaction({
                step: "get-offers-offer",
              });
              this.$emit("setStep", "get-offers-offer");
              this.$emit("input", response.data);
            }
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      product_category: null,
      source_of_income_values: [],
      source_of_incomes: [
        {
          key: "noincome",
          titleKey: "noincome",
          title: "Отсутствие дохода",
        },
        {
          key: "salary",
          titleKey: "salary",
          title: "Зарплата",
        },
        {
          key: "leasing",
          titleKey: "leasing",
          title: "Лизинг",
        },
        {
          key: "scholarship",
          titleKey: "scholarship",
          title: "Стипендия",
        },
        {
          key: "remittance",
          titleKey: "remittance",
          title: "Денежный перевод",
        },
        {
          key: "incomeofbusinessactivity",
          titleKey: "incomeofbusinessactivity",
          title: "Доход от предпринимательской деятельности",
        },
      ],
      field_of_activities: [
        {
          key: "Unemployed",
          titleKey: "unemployed",
          title: "Безработный",
        },
        {
          key: "Student",
          titleKey: "student",
          title: "Студент",
        },
        {
          key: "Employed",
          titleKey: "employed",
          title: "Работающий",
        },
        {
          key: "Entrepreneur",
          titleKey: "entrepreneur",
          title: "Предприниматель",
        },
      ],
      data: {
        region: {
          guid: "31f87e1b-18b8-11ea-b80a-b3e7319519dd",
          label: "АНДИЖОН ВИЛОЯТИ",
        },
        city: {
          guid: "fd0d34b3-4897-11ed-b823-c550a0567f26",
          label: "Андижон шахри",
        },
        education_degree: {
          guid: "b2876aff-38b3-11ec-b81a-df71afaf00f4",
          label: "Высшее",
        },
        steet: "Avisozlar 1",
        has_green_card: false,
        source_of_income: ["salary"],
        field_of_activity: "",
        agent_recommendation: {
          guid: "edeff9a5-8577-11ec-b81e-c63542292c2e",
          label: "Рекомендую",
        },
        additional_contact: [
          {
            additional_client_number: "+998903467899",
            name: "Test 1",
            relation: {
              guid: "7d20a6ec-1514-11ea-b809-95e43148036a",
              label: "Брат/сестра",
            },
          },
          {
            additional_client_number: "+998935604715",
            name: "Test 2",
            relation: {
              guid: "7d20a6ec-1514-11ea-b809-95e43148036a",
              label: "Брат/сестра",
            },
          },
        ],
      },
    };
  },
};
</script>

